import { useState, useCallback } from "react";
import { PageContainer } from "@/components/layout/PageContainer";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { PaymentMethodList } from "./PaymentMethodList";
import { PaymentMethodForm } from "./PaymentMethodForm";
import type { PaymentMethod } from "./hooks";

export function PaymentMethodsPage() {
  const [formOpen, setFormOpen] = useState(false);
  const [editingMethod, setEditingMethod] = useState<PaymentMethod | null>(
    null
  );

  const handleEdit = useCallback((method: PaymentMethod) => {
    setEditingMethod(method);
    setFormOpen(true);
  }, []);

  const handleAdd = useCallback(() => {
    setEditingMethod(null);
    setFormOpen(true);
  }, []);

  const handleOpenChange = useCallback((open: boolean) => {
    setFormOpen(open);
    if (!open) setEditingMethod(null);
  }, []);

  return (
    <PageContainer>
      <div className="p-6 space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-semibold tracking-tight">Payment Methods</h2>
            <p className="text-sm text-muted-foreground mt-1">
              Configure how customers pay on your storefront
            </p>
          </div>
          <Button onClick={handleAdd} className="rounded">
            <Plus className="mr-2 h-4 w-4" />
            Add Method
          </Button>
        </div>

        <PaymentMethodList onEdit={handleEdit} />

        <PaymentMethodForm
          key={editingMethod?.name ?? "new"}
          open={formOpen}
          onOpenChange={handleOpenChange}
          editingMethod={editingMethod}
        />
      </div>
    </PageContainer>
  );
}
